import React from 'react'
import {Link} from "react-router-dom";
function Counsellor() {
  return (
    <>
    <style>{`
       .counsellor_background{
          background:rgba(209,209,247,0.7);
        }
        .counsellor_background h1{
          color: #2b1c50;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
            .counsellor_background h2{
          color: #2b1c50;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .counsellor_background p{
          color: var(--color-grey-darken-2);
          font-family: 'Poppins', sans-serif;
          font-size:0.9rem;
          user-select: none;
        }
      `}</style>
    <div>
      <div className='counsellor_background py-4 mb-5'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10 text-center'>
            <h2 className='display-6'>Talk to our Counsellor</h2>
            <p className='py-2'>Make an appointment with one of our certified counselors to get individualized assistance with your academic and career goals</p>
            <Link to='/Contact-Us'>
            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">Contact Us</button>
            </Link>
            </div>
            <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Counsellor
